import { IAppState } from '../../common/state';

export function selectCurrentPageNumber(state: IAppState): number {
  return state.results.jsonQuery.page ? state.results.jsonQuery.page.value : 1;
}
